import { render, staticRenderFns } from "./AllocateCourse.vue?vue&type=template&id=2956a7e3&"
import script from "./AllocateCourse.vue?vue&type=script&lang=js&"
export * from "./AllocateCourse.vue?vue&type=script&lang=js&"
import style0 from "./AllocateCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports